import { useCallback, useState } from "react";

export function useSimpleLoadMorePagination({
  defaultLimit = 10,
}: { defaultLimit?: number } = {}) {
  const limit = Number(defaultLimit)
  const [offset, setOffset] = useState(0)

  const onLoadMore = useCallback(() => {
    const nextOffset = offset + limit
    setOffset(nextOffset)
  }, [limit, offset])

  return {
    limit,
    offset,
    onLoadMore,
  }
}
